module.exports = __webpack_public_path__ + "static/profile-e901104744109cfacd1bcb8534b9a312.jpg";